const set = key => (state, val) => {
    state[key] = val;
};

const setStoreValue = (state, { key, value }) => {
    state[key] = value;
}

export {
    set,
    setStoreValue
};
